import { ExternalCalendarEvent, TimeFormatOptions } from '@griply/types';

import { formatTimeRange } from './format-time-range';
import { getCalendarEventReferenceDate } from './get-calendar-event-reference-date';
import { isExternalEventAllDay } from './is-external-event-all-day';

export type ExternalEventTimeLabel =
  | { isAllDay: true }
  | { isAllDay: false; range: string };

// A timed event spanning midnight stays timed rather than widening into the all-day row.
export const getExternalEventTimeLabel = (
  event: ExternalCalendarEvent,
  timeFormat: TimeFormatOptions,
): ExternalEventTimeLabel => {
  if (isExternalEventAllDay(event)) {
    return { isAllDay: true };
  }

  const fallback = new Date(0);
  const start = getCalendarEventReferenceDate(event.start, fallback);
  const end = getCalendarEventReferenceDate(event.end, fallback);

  return {
    isAllDay: false,
    range: formatTimeRange(start, end, timeFormat),
  };
};
